import clsx from "clsx";
import type { HTMLAttributes, ReactNode } from "react";

export interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  eyebrow?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  eyebrow,
  meta,
  actions,
  className,
  ...props
}: PageHeaderProps) {
  return (
    <div
      data-page-header
      className={clsx(
        "flex flex-wrap items-start justify-between gap-4",
        className,
      )}
      {...props}
    >
      <div className="min-w-0">
        {eyebrow ? (
          <p
            data-page-header-eyebrow
            className="mb-2 text-caption font-semibold uppercase tracking-[0.18em] text-content-accent"
          >
            {eyebrow}
          </p>
        ) : null}
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          <h1 className="font-display text-heading-xl font-semibold tracking-tight text-content-primary focus:outline-none">
            {title}
          </h1>
          {meta ? (
            <div className="min-w-0 basis-full sm:basis-auto">{meta}</div>
          ) : null}
        </div>
        {subtitle ? (
          <p className="mt-2 max-w-3xl text-body text-content-secondary">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex min-w-0 flex-wrap items-center justify-end gap-3">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
